import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getIncomes, getIncomesInRange, deleteIncomeById, createIncome, updateIncome } from "../api/income";
import { reportKeys } from "./reports";

export const incomeKeys = {
  all: ["incomes"] as const,
  list: (categoryId?: string) => [...incomeKeys.all, categoryId ?? "all"] as const,
  range: (start: string, end: string) => [...incomeKeys.all, "range", start, end] as const,
};

export function useIncomesQuery(categoryId?: string) {
  return useQuery({
    queryKey: incomeKeys.list(categoryId),
    queryFn: () => getIncomes(categoryId),
    staleTime: 30_000,
  });
}

export function useIncomesInRange(startDate: Date, endDate: Date) {
  const key = incomeKeys.range(startDate.toISOString(), endDate.toISOString());
  return useQuery({
    queryKey: key,
    queryFn: () => getIncomesInRange(startDate, endDate),
    enabled: !!startDate && !!endDate,
    staleTime: 30_000,
  });
}

export function useDeleteIncome() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string }) => deleteIncomeById(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: incomeKeys.all as unknown as string[] });
      // Invalidate reports since they depend on incomes
      qc.invalidateQueries({ queryKey: reportKeys.all as unknown as string[] });
    },
  });
}

export function useCreateIncome() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ date, amount, description, categoryTitle }: { date: Date; amount: number; description: string; categoryTitle: string }) =>
      createIncome(date, amount, description, categoryTitle),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: incomeKeys.all as unknown as string[] });
      // Invalidate reports since they depend on incomes
      qc.invalidateQueries({ queryKey: reportKeys.all as unknown as string[] });
    },
  });
}

export function useUpdateIncome() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, date, amount, description, categoryTitle }: { id: string; date: Date; amount: number; description: string; categoryTitle: string }) =>
      updateIncome(id, date, amount, description, categoryTitle),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: incomeKeys.all as unknown as string[] });
      // Invalidate reports since they depend on incomes
      qc.invalidateQueries({ queryKey: reportKeys.all as unknown as string[] });
    },
  });
}


